module.exports = __webpack_public_path__ + "media/images/emblems/Rickenbach-blason-3faae392ea2742a96ceb968cfe22440b.png";